'use strict';

const _ = require('underscore');
const i18n = require('i18next');
const Backbone = require('backbone');
const GroupPermissionFactory = require('common/domain/factory/group-permission');

module.exports = Backbone.Model.extend({
    defaults: {
        name: '',
        permissions: null,
        isDefaultRole: false
    },

    initialize: function() {
        const factory = new GroupPermissionFactory();
        this._permissions = new Backbone.Collection(
            _.map(this.get('permissions'), json => factory.build(json))
        );
    },

    getName: function() {
        if(this.isDefaultRole()) {
            return i18n.t(`base:group-role.${this.id}`);
        } else {
            return this.get('name');
        }
    },

    isDefaultRole: function() {
        return this.get('isDefaultRole');
    },

    isAnonymous: function() {
        return this.get('isAnonymous');
    },

    isSelectable: function() {
        return !this.isAnonymous();
    },

    getPermissions: function() {
        return this._permissions;
    },

    getPermission: function(permissionClass) {
        return this._permissions.find(p => {
            return p instanceof permissionClass;
        });
    },

    isAdmin: function() {
        return this.id == 'admin';
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/group-role.js